import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

import background from './assets/background.png?file';

export default makeStyles({ name: 'PromoBlock' })((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: 'auto',
        gap: 40,
        width: '100%',
        maxWidth: 1120,
        boxSizing: 'border-box',
        padding: '80px 24px 80px 80px',
        borderRadius: 16,
        background: `url(${background}) center / cover no-repeat #282D31`,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            padding: 24,
            flexDirection: 'column-reverse'
        }
    },
    main: {
        display: 'grid',
        gap: 40,
        alignItems: 'flex-start',
        boxSizing: 'border-box',
        flex: 1,
        maxWidth: 620
    },
    content: {
        position: 'relative',
        gridColumn: 1,
        gridRow: 1,
        opacity: 0,
        visibility: 'hidden'
    },
    visible: {
        opacity: 1,
        visibility: 'visible'
    },
    caption: {
        margin: 0,
        color: '#F5726A',
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '24px',
        letterSpacing: '1.6px',
        textTransform: 'uppercase',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            fontSize: 14,
            lineHeight: '21px',
            letterSpacing: '1.4px'
        }
    },
    title: {
        marginTop: 16,
        marginBottom: 32,
        color: '#FFF',
        fontSize: 40,
        fontWeight: 700,
        lineHeight: '48px',
        letterSpacing: '-1.2px',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            fontSize: 32,
            lineHeight: '120%',
            letterSpacing: '-0.96px'
        }
    },
    description: {
        margin: 0,
        color: '#FFF',
        fontSize: 20,
        fontWeight: 500,
        lineHeight: '30px',
        letterSpacing: '-0.6px',
        opacity: 0.8,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            fontSize: 18,
            lineHeight: '27px',
            letterSpacing: '-0.54px'
        }
    },
    actions: {
        gridColumn: 1,
        gridRow: 2
    },
    button: {
        padding: '16px 32px',
        borderRadius: 16,
        background: '#F8F8F8 !important',
        color: '#232323 !important',
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '24px',
        letterSpacing: '-0.32px'
    },
    control: {
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        justifyContent: 'center',
        gap: 8,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            flexDirection: 'row'
        }
    }
}));
